'use client';

import { useContext } from 'react';

import { DirectoryInteractionsContext } from '@/contexts/DirectoryInteractions';
import { caresourcerHomeUrl } from '@/directory/constants';

import { CareTypePicker } from './CareTypePicker';
import { SearchButton } from './SearchButton';
import { SearchField } from './SearchField';

export const CareTypePickerFromContext = () => {
  const { filters, modifyFilter } = useContext(DirectoryInteractionsContext);

  return (
    <CareTypePicker
      {...{
        ...filters.careType,
        setSelectedValue: (val: any) => modifyFilter('careType', val),
      }}
    />
  );
};

interface SearchButtonFromContextProps {
  text: string;
  fullWidth?: boolean;
  isDisabled?: boolean;
  initialSearchTerm?: string;
}
export const SearchButtonFromContext = ({
  text,
  initialSearchTerm,
}: SearchButtonFromContextProps) => {
  const { searchTerm, filters, isShowResultsInApp, searchFn } = useContext(
    DirectoryInteractionsContext,
  );

  const {
    careType: { selectedValue: careType },
  } = filters;

  if (isShowResultsInApp) {
    return (
      <SearchButton
        text={text}
        onClick={() => searchFn(searchTerm || initialSearchTerm)}
      />
    );
  }

  return (
    <SearchButton
      text={text}
      href={`${caresourcerHomeUrl}/uk/search?location=${searchTerm || initialSearchTerm}&care_type=${careType === 'homeCare' ? 'home_care' : 'care_home'}`.toLowerCase()}
    />
  );
};

interface SearchFieldFromContextProps {
  initialSearchTerm?: string;
}
export const SearchFieldFromContext = ({
  initialSearchTerm,
}: SearchFieldFromContextProps) => {
  const { searchFn, searchTerm, setSearchTerm } = useContext(
    DirectoryInteractionsContext,
  );

  return (
    <SearchField
      searchTerm={searchTerm || initialSearchTerm}
      setSearchTerm={setSearchTerm}
      searchFn={searchFn}
    />
  );
};
